var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page__content checkout"},[_c('div',{staticClass:"shine"}),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"cell large-8 large-offset-2 module__checkout"},[_c('app-header'),_c('bundle-loader')],1)])])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }